import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title?: string
  description?: string
  image?: string
  url?: string
  type?: 'website' | 'article'
  keywords?: string
}

const BASE_URL = 'https://beternakayam.com'
const DEFAULT_IMAGE = `${BASE_URL}/images/beternakayam.jpg`
const SITE_NAME = 'BeternakAyam.com'
const DEFAULT_KEYWORDS = 'beternak ayam, ternak ayam petelur, ternak ayam pedaging, penyakit ayam, vaksinasi ayam, pakan ayam, tips ternak ayam'

export function SEO({
  title,
  description = 'Panduan lengkap beternak ayam untuk peternak Indonesia: jenis ayam petelur & pedaging, penyakit & pengobatan, jadwal vaksinasi, kalkulator racik pakan, racikan obat & jamu.',
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  keywords,
}: SEOProps) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} - Panduan Lengkap Beternak Ayam Indonesia`

  const fullUrl = url ? `${BASE_URL}${url}` : BASE_URL
  const fullImage = image.startsWith('http') ? image : `${BASE_URL}${image}`
  const allKeywords = keywords
    ? `${keywords}, ${DEFAULT_KEYWORDS}`
    : DEFAULT_KEYWORDS

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={allKeywords} />

      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="id_ID" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  )
}
